import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

export default function AdminNetwork() {
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    const tick = () => api.get("/analytics/overview").then(({ data }) => setOverview(data));
    tick();
    const t = setInterval(tick, 5000);
    return () => clearInterval(t);
  }, []);

  if (!overview) return <div className="p-8 text-zinc-500 font-mono text-xs">LOADING…</div>;

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">NETWORK OPS</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Mission Control</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
        <KPI label="Stations" value={overview.stations_total} color="#fff" />
        <KPI label="Online" value={overview.stations_online} color="#4ADE80" />
        <KPI label="Capacity" value={`${overview.total_capacity_kw}kW`} color="#00E5FF" />
        <KPI label="Battery" value={`${overview.battery_state_pct}%`} color="#FFA800" />
        <KPI label="Revenue" value={`$${overview.total_revenue_usd.toFixed(0)}`} color="#FACC15" />
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="bin-card p-6">
          <div className="bin-label mb-4">HOURLY ENERGY DELIVERY · KWH</div>
          <ResponsiveContainer width="100%" height={280}>
            <AreaChart data={overview.hourly_kwh}>
              <defs>
                <linearGradient id="g1" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#00E5FF" stopOpacity={0.4} />
                  <stop offset="100%" stopColor="#00E5FF" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="2 4" stroke="#27272A" />
              <XAxis dataKey="hour" tick={{ fill: "#71717A", fontSize: 10 }} />
              <YAxis tick={{ fill: "#71717A", fontSize: 10 }} />
              <Tooltip contentStyle={{ background: "#0F0F11", border: "1px solid #27272A" }} />
              <Area type="monotone" dataKey="kwh" stroke="#00E5FF" strokeWidth={2} fill="url(#g1)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="bin-card p-6">
          <div className="bin-label mb-4">PRIORITY DISTRIBUTION</div>
          <div className="space-y-3">
            {Object.entries(overview.priority_breakdown).map(([k, v]) => {
              const total = Object.values(overview.priority_breakdown).reduce((a, b) => a + b, 0);
              const pct = total > 0 ? (v / total) * 100 : 0;
              const color = {
                emergency: "#FF3838", medical: "#00D2FF", public_safety: "#FF8A00",
                premium: "#FACC15", standard: "#E4E4E7", background: "#71717A",
              }[k] || "#71717A";
              return (
                <div key={k}>
                  <div className="flex items-center justify-between text-xs font-mono mb-1">
                    <span className="uppercase tracking-wider text-zinc-400">{k.replace("_", " ")}</span>
                    <span style={{ color }}>{v}</span>
                  </div>
                  <div className="h-1.5 bg-zinc-900 rounded overflow-hidden">
                    <div style={{ width: `${pct}%`, background: color }} className="h-full transition-all" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function KPI({ label, value, color }) {
  return (
    <div className="bin-card p-4">
      <div className="bin-label">{label}</div>
      <div className="text-2xl font-black font-mono mt-1" style={{ color }}>{value}</div>
    </div>
  );
}
